import { Component, OnInit } from "@angular/core";
import { UsersService } from "../services/users/users.service";
import { ToastrService } from "ngx-toastr";
import { forkJoin } from "rxjs";

@Component({
    selector: "app-contul-meu",
    templateUrl: "./contul-meu.component.html",
    styleUrls: ["./contul-meu.component.scss"],
})
export class ContulMeuComponent implements OnInit {
    // DATE
    user: any = null;
    appointments: any[] = [];
    results: any[] = [];
    tickets: any[] = [];
    documents: any[] = [];
    notifications: any[] = [];

    // LOADING per card
    loadingUser = true;
    loadingAppointments = true;
    loadingResults = true;
    ticketsInternal: any[] = [];
    ticketsExternal: any[] = [];
    homeTickets: any[] = [];

    // dashboard.component.ts (sau ce fișier e)
    selectedAppointment: any | null = null;

    loadingTickets = true;
    loadingDocuments = true;
    loadingNotifications = true;

    hasMedicalData = false;

    showGdprModal = false;
    gdprChoice: "agree" | "disagree" | null = null;

    editingContact = false;

    editContact = {
        phone: "",
        email: "",
    };

    unreadCount = 0;

    constructor(
        private usersService: UsersService,
        private toastr: ToastrService,
    ) {}

    ngOnInit(): void {
        // Start toate loading-urile
        this.loadAllData();
    }

    /** SIMPLE: Încarcă unul câte unul - NU anulează nimic */
    loadAllData(): void {
        this.loadUser();
        setTimeout(() => this.loadAppointments(), 100);
        setTimeout(() => this.loadResults(), 200);
        setTimeout(() => this.loadTickets(), 300);
        setTimeout(() => this.loadDocuments(), 400);
        setTimeout(() => this.loadNotifications(), 500);
    }

    // 1. USER
    loadUser(): void {
        this.usersService.getPatient().subscribe({
            next: (data) => {
                this.user = data;
                this.loadingUser = false;
                // console.log("✅ User:", data);
            },
            error: (err) => {
                // console.warn("⚠️ User API error:", err);
                this.loadingUser = false;
                this.user = null;
            },
        });
    }

    // 2. PROGRAMĂRI
    loadAppointments(): void {
        this.usersService.getMyAppointments().subscribe({
            next: (data) => {
                const now = new Date();

                // Filtrează doar programările active (viitoare)
                this.appointments = (data || []).filter((appt) => {
                    const apptDate = new Date(appt.startDate);

                    // Dacă există startHour, adaugă și ora
                    if (appt.startHour) {
                        const [hours, minutes] = appt.startHour.split(":");
                        apptDate.setHours(parseInt(hours), parseInt(minutes));
                    }

                    // Returnează doar programările viitoare
                    return apptDate >= now;
                });

                this.loadingAppointments = false;
                // console.log(
                //     "✅ Active Appointments:",
                //     this.appointments.length,
                // );
            },
            error: () => {
                this.appointments = [];
                this.loadingAppointments = false;
                console.log("⚠️ Appointments error");
            },
        });
    }

    // 3. REZULTATE
    loadResults(): void {
        this.usersService.getTopResults(3).subscribe({
            next: (data) => {
                this.results = data || [];
                this.loadingResults = false;
                // console.log("✅ Results:", data?.length || 0);
            },
            error: () => {
                this.results = [];
                this.loadingResults = false;
            },
        });
    }

    // 4. BILETE
    loadTickets(): void {
        this.loadingTickets = true;

        forkJoin({
            internal: this.usersService.getMyTicketsTop(5),
            external: this.usersService.getMyExternalTicketsTop(5), // schimbă cu metoda ta reală
        }).subscribe({
            next: ({ internal, external }) => {
                this.ticketsInternal = internal || [];
                this.ticketsExternal = external || [];

                const internalMarked = this.ticketsInternal.map((t) => ({
                    ...t,
                    isExternal: false,
                }));

                const externalMarked = this.ticketsExternal.map((t) => ({
                    ...t,
                    isExternal: true,
                }));

                // combină și sortează descrescător după dată
                this.homeTickets = [...internalMarked, ...externalMarked].sort(
                    (a, b) => {
                        const da = new Date(
                            a.date || (a.createdDate as any),
                        ).getTime();
                        const db = new Date(
                            b.date || (b.createdDate as any),
                        ).getTime();
                        return db - da;
                    },
                );

                this.loadingTickets = false;
                // console.log(
                //     "✅ Tickets interne:",
                //     internal?.length || 0,
                //     this.homeTickets,
                // );
                // console.log(
                //     "✅ Tickets externe:",
                //     external?.length || 0,
                //     external,
                // );
            },
            error: () => {
                this.ticketsInternal = [];
                this.ticketsExternal = [];
                this.homeTickets = [];
                this.loadingTickets = false;
            },
        });
    }

    // 5. DOCUMENTE
    loadDocuments(): void {
        this.usersService.getMyDocumentsTop(3).subscribe({
            next: (data) => {
                this.documents = data || [];
                this.loadingDocuments = false;
                // console.log("✅ Documents:", data?.length || 0);
            },
            error: () => {
                this.documents = [];
                this.loadingDocuments = false;
            },
        });
    }

    // 6. NOTIFICĂRI

    updateMedicalDataStatus(): void {
        this.hasMedicalData = !!(
            this.appointments.length ||
            this.results.length ||
            this.documents.length
        );
    }

    // ACTIONS
    updateGDPR(): void {
        this.usersService.updateDetails({ isGdpr: true }).subscribe({
            next: () => this.toastr.success("✅ GDPR semnat!"),
            error: () => this.toastr.error("❌ Eroare GDPR"),
        });
    }

    downloadAllDocuments(): void {
        // this.documents.forEach(doc => {
        //   this.usersService.downloadDocument(doc.downloadReference, `${doc.name}.${doc.fileExtension}`);
        // });
        this.toastr.success(`📥 ${this.documents.length} documente!`);
    }

    logout(): void {
        // this.usersService.logout().subscribe({
        //   next: () => {
        //     localStorage.clear();
        //     this.toastr.info('👋 Logout!');
        //     // window.location.href = '/login';
        //   }
        // });
    }

    trackByFn(index: number, item: any): any {
        return item?.uid || item?.id || index;
    }

    viewDetails(appt: any): void {
        this.selectedAppointment = appt;
    }

    closeDetails(): void {
        this.selectedAppointment = null;
    }

    reschedule(appt: any): void {
        // redirect către flow de reprogramare
    }

    cancel(appt: any): void {
        // Confirmă înainte de anulare
        if (
            !confirm(
                `Sigur dorești să anulezi programarea cu Dr. ${appt.doctorName}?`,
            )
        ) {
            return;
        }

        const cancelData = {
            eventId: appt.event.uid,
            scheduleId: appt.schedule.uid,
        };

        this.usersService.cancelAppointment(cancelData).subscribe({
            next: () => {
                // Succes - reîncarcă lista de programări
                this.loadAppointments();

                // Mesaj de succes (dacă ai toastr)
                this.toastr?.success(
                    "Programarea a fost anulată cu succes",
                    "Anulare programare",
                );

                console.log("✅ Appointment canceled");
            },
            error: (err) => {
                // Eroare - afișează mesaj
                this.toastr?.error(
                    "Eroare la anularea programării. Încercați din nou.",
                    "Eroare",
                );

                console.error("❌ Cancel appointment error:", err);
            },
        });
    }

    getStatus(appt: any) {
        // console.log(appt);
        return "Activa";
    }

    download(document: any) {
        const t = this;
        t.usersService.download(document);
    }
    goToGdpr(): void {
        this.gdprChoice = null;
        this.showGdprModal = true;
    }

    closeGdprModal(): void {
        this.showGdprModal = false;
    }

    confirmGdpr(): void {
        if (this.gdprChoice === "agree") {
            // aici faci call la backend să setezi isGdpr = true
            // de ex: this.userService.updateGdpr(true).subscribe(...)
            this.user = { ...this.user, isGdpr: true };
              this.usersService.updateGdpr({ isGdprSigned: 'true' }).subscribe({
            next: () => this.toastr.success("✅ GDPR semnat!"),
            error: () => this.toastr.error("❌ Eroare GDPR"),
        });
        } else {
            // opțional: loghezi refuzul, trimiți la backend etc.
            this.user = { ...this.user, isGdpr: false };
        }

        this.closeGdprModal();
    }

    saveContact(): void {
        const payload = {
            phone: this.editContact.phone,
            email: this.editContact.email,
        };


         this.usersService.updateDetails(payload).subscribe({
            next: () => {
                this.user = { ...this.user, ...payload };
                this.editingContact = false;
                this.toastr.success("✅ Utilizator actualizat!");},
            error: () => this.toastr.error("❌ Eroare "),
        });

        // // apelezi API-ul tău de update profil
        // this.usersService.updateContact(payload).subscribe({
        //     next: (updatedUser) => {
        //         this.user = { ...this.user, ...updatedUser };
        //         this.editingContact = false;
        //     },
        //     error: () => {
        //         // opțional: toast / mesaj de eroare
        //     },
        // });
    }
    loadNotifications(): void {
        this.loadingNotifications = true;

        this.usersService.getNotifications().subscribe({
            next: (data) => {
                // sortează descrescător după createdAt
                this.notifications = (data || []).sort(
                    (a, b) =>
                        new Date(b.createdAt).getTime() -
                        new Date(a.createdAt).getTime(),
                );

                // calculează local numărul de necitite
                this.unreadCount = this.notifications.filter(
                    (n) => !n.read,
                ).length;

                this.loadingNotifications = false;
            },
            error: () => {
                this.notifications = [];
                this.unreadCount = 0;
                this.loadingNotifications = false;
            },
        });
    }

    // click pe un singur notificare
    openNotification(notif: any): void {
        // dacă e necitită, marcheaz-o ca citită
        if (!notif.read) {
            this.usersService.markNotificationAsRead(notif.id).subscribe({
                next: () => {
                    notif.read = true;
                    if (this.unreadCount > 0) {
                        this.unreadCount--;
                    }
                },
                error: () => {
                    // chiar dacă API-ul pică, nu blocăm UI-ul
                },
            });
        }

        // TODO: navighează în funcție de tip + referenceId
        // exemplu (adaptezi tu la rutele tale):
        /*
  switch (notif.type) {
    case 'RESULT':
      this.router.navigate(['/rezultatele-mele'], {
        queryParams: { uuid: notif.referenceId }
      });
      break;
    case 'APPOINTMENT':
      this.router.navigate(['/programarile-mele']);
      break;
    // etc.
  }
  */
    }

    // click pe „Marchează toate ca citite”
    markAllAsRead(): void {
        this.usersService.markAllNotificationsAsRead().subscribe({
            next: (res) => {
                this.notifications = this.notifications.map((n) => ({
                    ...n,
                    read: true,
                }));
                this.unreadCount = 0;
            },
            error: () => {
                // poate pui un toastr
            },
        });
    }
}
